import { render, staticRenderFns } from "./chat-element-rebot.vue?vue&type=template&id=45662861&scoped=true"
import script from "./chat-element-rebot.vue?vue&type=script&lang=js"
export * from "./chat-element-rebot.vue?vue&type=script&lang=js"
import style0 from "./chat-element-rebot.vue?vue&type=style&index=0&id=45662861&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45662861",
  null
  
)

export default component.exports